module.exports = __webpack_public_path__ + "img/icon-image-no.7bbf283d.jpg";